import React from 'react';
import { useTheme } from 'ThemeContext';

import {
  Wrapper,
  Box,
  Item,
  ItemExternal,
  Text,
  Arrow
} from './MegamenuList.style';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function MegamenuList({ data = [] }) {
  const theme = useTheme();

  const renderItemInner = data => {
    return (
      <Text theme={theme.megamenuList.text}>
        {data.title}
        <Arrow theme={theme.megamenuList.arrow}>
          <FontAwesomeIcon icon={theme.megamenuList.arrow.faIcon} />
        </Arrow>
      </Text>
    );
  };

  return (
    <>
      {data && data.length > 0 ? (
        <Wrapper theme={theme.megamenuList.wrapper}>
          <Box>
            {data.map((item, key) =>
              (item.slug && /(http(s?)):\/\//gi.test(item.slug)) ||
              (item.url && /(http(s?)):\/\//gi.test(item.url)) ||
              item.url_outside ? (
                <ItemExternal
                  theme={theme.megamenuList.item}
                  key={key}
                  title={item.title}
                  href={item.slug || item.url || item.url_outside}
                  target={
                    item._blank || item.url_blank || item.url_outside_blank
                      ? '_blank'
                      : '' || item.target || ''
                  }
                  rel={
                    item.nofollow ||
                    item.url_nofollow ||
                    item.url_outside_nofollow
                      ? 'nofollow'
                      : '' || item.rel || ''
                  }
                >
                  {renderItemInner(item)}
                </ItemExternal>
              ) : (
                <Item
                  theme={theme.megamenuList.item}
                  key={key}
                  title={item.title}
                  smooth
                  lastItem={key === data.length - 1}
                  to={
                    item.slug && (item.slug[0] === '/' || item.slug[0] === '#')
                      ? item.slug
                      : `/${item.slug}`
                  }
                >
                  {renderItemInner(item)}
                </Item>
              )
            )}
          </Box>
        </Wrapper>
      ) : (
        ''
      )}
    </>
  );
}

export default MegamenuList;
